export const CACHE_KEYS = {
    USER: 'user',
    USER_IMAGE: 'userImage',
    AUTH_CONFIG: 'auth_config',
    AUTH_TYPE: 'auth_type',
    CORPORATE: 'corp',
    PERMISSIONS: 'permissions',
    REMEMBER_USERNAME: 'rememberedEmail',
    MASTER_VIEW: 'masterView',
    FOLDERS: 'folders',
    FOLDERS_PERMISSIONS: 'folders_permissions',
    USER_PERMISSION: 'user_permission',
};
